export const datePickerLocaleDEde = { start: "Von", end: "Bis" }
